var COORXY = /** @class */ (function () {
    // tslint:disable-next-line:no-empty
    function COORXY() {
    }
    return COORXY;
}());
export default COORXY;
